import { useCallback, useState } from 'react';

import { useDocumentSourceUrl } from './use-document-source-url';

import type { DocumentSourceChunk } from '../components/document-source-modal';

export interface UseDocumentSourceResult {
  sourceChunk: DocumentSourceChunk | null;
  readUrl: string | undefined;
  isLoading: boolean;
  hasError: boolean;
  isUnconvertible: boolean;
  showSource: (chunk: DocumentSourceChunk) => void;
  closeSource: () => void;
}

export const useDocumentSource = (): UseDocumentSourceResult => {
  const [sourceChunk, setSourceChunk] = useState<DocumentSourceChunk | null>(null);

  const source = useDocumentSourceUrl(sourceChunk?.documentPackageId, sourceChunk?.blobId);

  return {
    sourceChunk,
    ...source,
    showSource: useCallback((chunk: DocumentSourceChunk) => setSourceChunk(chunk), []),
    closeSource: useCallback(() => setSourceChunk(null), []),
  };
};
